import React from 'react'
import './PaymentSuccess.css'

const PaymentSuccess = () => {
  return (
    <div>
      <h1>Payment success Page</h1>
    </div>
  )
}

export default PaymentSuccess
